module.exports = __webpack_public_path__ + "static/media/earth.54b256cc.webp";